module.exports = "https://web-assets.ifttt.com/packs/media/icons/fog-fd508499.png";